var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-chart-wrapper",class:{ 'bar-chart-wrapper--compact': _vm.compact },style:(_vm.compact ? { height: (_vm.height + "px") } : undefined)},[_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }